module.exports = __webpack_public_path__ + "static/baby-yoda-2c3dcf971d61edbbe1d3ed786d6e8d8b.webm";